export const FILTER_PAGE = 'FILTER_PAGE'
